import { Download, CalendarCheck, ScrollText, HelpCircle, Phone } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { WhatsAppIcon } from '../../utils/Quick Links/Links';

const links = [
  {
    id: 'mobile',
    icon: Phone,
    label: 'Call Us',
    href: 'tel:+16195670156',
    external: true
  },
  {
    id: 'whatsapp',
    icon: WhatsAppIcon,
    label: 'WhatsApp',
    href: 'https://api.whatsapp.com/send/?phone=16195670156&text=Hello&type=phone_number&app_absent=0',
    external: true
  },
  {
    id: 'abstract-submission',
    icon: ScrollText,
    label: 'Submit Abstract',
    href: '/abstract-submission',
    external: false
  },
  {
    id: 'brochure-download',
    icon: Download,
    label: 'Brochure Download',
    href: '/brochure-download',
    external: false
  },
  {
    id: 'event-schedule',
    icon: CalendarCheck,
    label: 'Schedule',
    href: '/pharmaceutical-event-schedule',
    external: false
  },
  {
    id: 'faq',
    icon: HelpCircle,
    label: 'FAQs',
    href: '/faq',
    external: false
  }
];

const QuickLinks = () => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <>
      <style>{`
        @keyframes pulseShadow {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(59, 176, 94, 0.68);
          }
          50% {
            box-shadow: 0 0 20px 6px rgb(122,179,38);
          }
        }

        .animate-pulseShadow {
          animation: pulseShadow 2s ease-in-out infinite;
        }

        .transition-custom {
          transition: all 0.8s ease-in-out;
        }
      `}</style>

      <div className="fixed bottom-14 right-0 z-20 flex flex-col space-y-3">
        {links.map(({ id, icon: Icon, label, href, external, download }) => {
          const isActive = hoveredId === id;

          const commonClasses = `
            flex items-center bg-white shadow-md rounded-l-full overflow-hidden 
            transform transition-all duration-300 
            ${isActive ? 'translate-x-0' : 'translate-x-40'}
            ${id === 'mobile' ? 'animate-pulseShadow' : ''}
          `;

          const content = (
            <>
              <div className="bg-one text-white p-3 flex items-center justify-center rounded-l-full transition-custom">
                <Icon className="h-5 w-5" />
              </div>
              <span className="ml-4 pr-4 text-sm font-medium text-gray-800 whitespace-nowrap">
                {label}
              </span>
            </>
          );

          // External Links (Call, WhatsApp, PDF)
          if (external) {
            return (
              <a
                key={id}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                download={download ? true : undefined}
                onMouseEnter={() => setHoveredId(id)}
                onMouseLeave={() => setHoveredId(null)}
                className={commonClasses}
              >
                {content}
              </a>
            );
          }

          // Internal React Routes
          return (
            <Link
              key={id}
              to={href}
              onMouseEnter={() => setHoveredId(id)}
              onMouseLeave={() => setHoveredId(null)}
              className={commonClasses}
            >
              {content}
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default QuickLinks;